var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',[_c('TabPane',{attrs:{"label":"58生意转让新版"}},[_c('list2')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }